export const initialState = {
  salereport: null,
};

export const sale_report = (state = initialState, action) => {
  switch (action.type) {
    case "SALE_REPORT":
      return {
        salereport: action.payload,
      };
    default:
      return state;
  }
};
